import { formatClockLabel, titleize } from "../../utils/time";


interface BehavioralEvent {
  tSec: number;
  startSec: number;
  endSec: number;
  event: string;
  severity: string;
}

interface BehavioralEventsCardProps {
  events: BehavioralEvent[];
  onSeek: (seconds: number) => void;
}

function BehavioralEventsCard({
  events,
  onSeek,
}: BehavioralEventsCardProps) {
  return (
    <section className="card">
      <h2 className="sidebar-heading">BEHAVIOURAL EVENTS TIMESTAMP</h2>

      {events.length === 0 ? (
        <div className="empty-state">
          No records found
        </div>
      ) : (
        <div className="event-grid">
          {events.map((event) => {
            return (
              <button
                key={`${event.tSec}-${event.event}`}
                type="button"
                className={`event-card ${
                  event.severity === "warn"
                    ? "event-card--warn"
                    : ""
                }`}
                onClick={() => onSeek(event.tSec)}
              >
                <div className="event-header">
                  <div className="event-column">
                    <span className="event-caption">
                      Start
                    </span>

                    <span className="event-time">
                      {formatClockLabel(event.startSec)}
                    </span>
                  </div>

                  <div className="event-column">
                    <span className="event-caption">
                      End
                    </span>

                    <span className="event-time">
                      {formatClockLabel(event.endSec)}
                    </span>
                  </div>
                </div>

                <span className="event-label">
                  {titleize(event.event)}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </section>
  );
}

export default BehavioralEventsCard;